import { render, staticRenderFns } from "./resetPassword.vue?vue&type=template&id=7b47e3b1"
import script from "./resetPassword.vue?vue&type=script&lang=js"
export * from "./resetPassword.vue?vue&type=script&lang=js"
import style0 from "./resetPassword.vue?vue&type=style&index=0&id=7b47e3b1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports